import React, { useState } from 'react';

import { useTranslation } from 'react-i18next';
import { Tabs, TabPane } from '@bringg/react-components';
import { ColumnLabelsManager } from '@bringg-frontend/column-labels-manager';

import { useHasFeatureFlag } from 'bringg-web/utils/feature-flags';
import GeneralTab from './general-tab/general-tab';

import './web-user-interface.scss';

export type { DashboardUiConfigurationOnMerchantLevelForm } from './general-tab/general-tab';
export { orderPageOptions } from './general-tab/general-tab';

const GENERAL_TAB_KEY = 'general';
const COLUMN_LABELS_TAB_KEY = 'column-labels';
const COLUMN_LABELS_MANAGER_FF = 'enable_column_labels_manager';
const ORDER_EXPLORER_FF = 'enable_order_explorer';

const WebUserInterface: React.FC = () => {
	const { t } = useTranslation();
	const [activeTab, setActiveTab] = useState<string>(GENERAL_TAB_KEY);
	const hasColumnLabelsManager = useHasFeatureFlag(COLUMN_LABELS_MANAGER_FF);
	const hasOrderExplorerEnabled = useHasFeatureFlag(ORDER_EXPLORER_FF);

	return (
		<div className="web-user-interface">
			<Tabs
				className="web-user-interface-tabs"
				activeKey={activeTab}
				onChange={setActiveTab}
				data-test-id="web-user-interface-tabs"
			>
				<TabPane tab={t('WEB_USER_INTERFACE.TABS.GENERAL')} key={GENERAL_TAB_KEY}>
					<GeneralTab />
				</TabPane>
				{hasColumnLabelsManager && hasOrderExplorerEnabled && (
					<TabPane tab={t('WEB_USER_INTERFACE.TABS.COLUMN_LABELS')} key={COLUMN_LABELS_TAB_KEY}>
						<ColumnLabelsManager />
					</TabPane>
				)}
			</Tabs>
		</div>
	);
};

export default WebUserInterface;
